// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM11.9995 8.58575L9.17105 5.75732L7.75684 7.17154L10.5853 9.99996L7.75684 12.8284L9.17105 14.2426L11.9995 11.4142L14.8279 14.2426L16.2421 12.8284L13.4137 9.99996L16.2421 7.17154L14.8279 5.75732L11.9995 8.58575Z"}}]};

const ChatClearFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-clear-filled',
    ref,
    icon: element,
  },
));

ChatClearFilledIcon.displayName = 'ChatClearFilledIcon';

export default ChatClearFilledIcon;
